module.exports = __webpack_public_path__ + "assets/img/store-text-phone-2.1f8cd7c0.png";